import { gql } from '@/__generated__';

const GET_INTEGRATION_GROUPED_ISSUES_COUNT = gql(`#graphql
  query GetIntegrationGroupedIssuesCount($integrationId: Int!, $input: WriteExecutionLogsGroupedIssuesInput) {
    integration(input: { id: $integrationId }) {
      id
      writeExecutionLogGroupedIssues(input: $input) {
        id
        pageInfo {
          totalCount
        }
      }
    }
  }
`);

export default GET_INTEGRATION_GROUPED_ISSUES_COUNT;
